// extracted by mini-css-extract-plugin
export default {"center":"ToolTile_center__f9hoB","container":"ToolTile_container__bl0w6"};